import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFocusRemove"><Path d="M9 3H3V9H5V5H9V3Z" fill="currentColor"/><Path d="M21 3H15V5H19V9H21V3Z" fill="currentColor"/><Path d="M5 19V15H3V21H9V19H5Z" fill="currentColor"/><Path d="M21 21V15H19V19H15V21H21Z" fill="currentColor"/><Path d="M12 10.5858L9.87869 8.46448L8.46448 9.87869L10.5858 12L8.46448 14.1213L9.87869 15.5355L12 13.4142L14.1213 15.5355L15.5355 14.1213L13.4142 12L15.5355 9.87869L14.1213 8.46448L12 10.5858Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFocusRemove;
